import { NextPage } from "next";
import LoginPage from "src/domains/login/LoginPage";
import { SiteMeta } from "src/domains/shared/components/Home/SiteShell/SiteMeta";

const Login: NextPage = () => {
  return (
    <>
      <SiteMeta page="login" />
      <LoginPage />
    </>
  );
};

export default Login;
